// Recently opened study tools, for the start page's "Jump back in" row
// (docs/HOME-2026-10.md, F3). Written by the tools pages when a tool opens, read by the
// app. Ids only (no content); paused in incognito and when history is off.
import { readJSON, writeJSON, subscribe as storeSubscribe } from "../shared/store.js";
import { TOOLS } from "../shared/tools-manifest.js";
import { enabled } from "../shared/activity.js";

export const KEY = "revault:tool-recents";
const LIMIT = 8;
const known = (id) => TOOLS.some((t) => t.id === id);

export function list() {
	const v = readJSON(KEY, []);
	if (!Array.isArray(v)) return [];
	const seen = new Set();
	return v.filter((r) => r && typeof r.id === "string" && known(r.id) && Number.isFinite(r.ts) && !seen.has(r.id) && seen.add(r.id));
}
export function record(id, now = Date.now()) {
	if (!known(id) || !enabled()) return;
	writeJSON(KEY, [{ id, ts: now }, ...list().filter((r) => r.id !== id)].slice(0, LIMIT));
}
export function remove(id) { writeJSON(KEY, list().filter((r) => r.id !== id)); }
export function subscribe(fn) { return storeSubscribe(KEY, fn); }
